import { Factory } from 'rosie';

Factory.define('ExternalCustomerLookupResults');

Factory.define('ExternalCustomerLookupResultsWithDefaults')
  .extend('ExternalCustomerLookupResults')
  .attr('id', 'some-correlation-id')
  .attr('results', () => [Factory.attributes('ExternalCustomerProfileWithDefaults')]);

Factory.define('ExternalCustomerProfile');

Factory.define('ExternalCustomerProfileWithDefaults')
  .extend('ExternalCustomerProfile')
  .attr('address', '42 Wallaby Way\nSydney, Australia')
  .attr('customAttributes', {
    favoriteDay: 'Sunday',
    favoriteFruit: 'Apple',
  })
  .attr('emails', () => [Factory.attributes('CustomerEmailAddressPrimary')])
  .attr('externalCustomerId', 'example-external-customer-id')
  .attr('name', 'Dory')
  .attr('phones', () => [Factory.attributes('PhoneNumberWithDefaults')]);



// WEBPACK FOOTER //
// ./factories/external_customer_lookup_results_factory.js